var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSinyonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 107,
    viewBox: "0 0 172 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C565F",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.239 81.751L149.239 86.155 164.544 86.155 149.239 99.384 149.239 103.793 171.27 103.793 171.27 99.384 156.007 99.384 171.27 86.127 171.27 81.751zM149.239 2.416L149.239 6.823 164.544 6.823 149.239 20.05 149.239 24.45 171.27 24.45 171.27 20.05 156.007 20.05 171.27 6.788 171.27 2.416zM149.239 61.044L155.934 66.323 149.239 71.621 149.239 77.343 160.259 68.528 171.27 68.528 171.27 64.116 160.259 64.116 149.239 55.303zM166.87 42.083c0 3.65-2.959 6.609-6.612 6.609-3.654 0-6.609-2.96-6.609-6.61 0-3.652 2.955-6.607 6.61-6.607 3.652 0 6.61 2.955 6.61 6.608m-17.63 0c0 6.084 4.934 11.02 11.02 11.02 6.084 0 11.02-4.936 11.02-11.02 0-6.086-4.936-11.021-11.02-11.021-6.086 0-11.02 4.935-11.02 11.02M21.56 70.073c0 13.475 10.5 18.725 22.418 18.725 7.799 0 19.715-2.273 19.715-12.627 0-10.92-15.17-12.765-30.07-16.736-15.04-3.972-30.215-9.788-30.215-28.79C3.408 9.927 22.978 0 41.284 0 62.414 0 81.85 9.22 81.85 32.628H60.29c-.71-12.2-9.364-15.325-19.996-15.325-7.1 0-15.328 2.983-15.328 11.498 0 7.793 4.823 8.788 30.21 15.314 7.383 1.844 30.078 6.526 30.078 29.506 0 18.58-14.61 32.483-42.127 32.483-22.416 0-43.413-11.064-43.125-36.031H21.56zM105.363 103.689L127.637 103.689 127.637 2.416 105.363 2.416z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinyonLogo);
export default __webpack_public_path__ + "static/media/sinyon-logo.9ba919ac89aaa075ff8f0ded50a49449.svg";
export { ForwardRef as ReactComponent };